import {Card} from "./Card";
import { SearchTarget } from "./SearchTarget";

var attendees_list_card_template = require('./attendees_list_card.twig');

export class AttendeesListCard extends Card {
    constructor() {
        super();
        this.dom = $(twig({ data: attendees_list_card_template }).render());
        
        //add attendees button
        this.dom.find('.search_target_button').on('click', (event) => {
            this.project_id = app.pages.meetingrequest.formCards.project_card.project_id;
            this.program_type_id = app.pages.meetingrequest.formCards.project_card.program_type_id;

            let ppConfig = app.appData.projects[this.project_id].program_types[this.program_type_id].configuration.sb.meeting_request;
            this.min_req_att =  ppConfig?.min_req_att ?? 0;

            event.preventDefault();
            this.searchTarget = new SearchTarget(this.attendeeData, this.min_req_att);
            this.searchTarget.reset();
            this.searchTarget.modal.show();
        })

        this.attendeeData =[]

        this.datatable = this.dom.find("#datatable_meeting_attendees").DataTable({
            "processing": true,
            "serverSide": false,
            "ordering": false,
            "data": [],
            "columns": [
                { title: "First Name", data: "firstname" },
                { title: "Last Name", data: "lastname" },
                { title: "Degree", data: "degree" },
                { title: "Address", data: "address" },
                { title: "City", data: "city" },
                { title: "State", data: "state" },
                {
                    title: "Action",
                    data: "target_id",
                    render: function (data) {
                        return `
                            <button class="delete-btn btn delete-target btn-danger"  data-id="${data}">Delete</button>
                            <input type="hidden" class="target-id" value="${data}">
                        `;
                    },
                    orderable: false,
                    searchable: false
                }
            ],
            "pagingType": "full_numbers",
            "width" : "100%",
            "dom": '<"row"<"col-6"l><"col-6"<"row">>><t>pri',
            "deferLoading": 1,
            "pageLength": 25,
            "scrollCollapse": true,
            "language": {
                "loadingRecords": 'Please wait while we fetch your results.',
                "emptyTable":     "No Results",
                "processing": 'Please wait while we fetch your results.'
            }
        });

        this.dom.find("#datatable_meeting_attendees tbody").on('click', '.delete-target', (e) => {
            let targetId = $(e.target).data("id")
            $(e.target).parents('tr').hide()
            this.attendeeData = this.attendeeData.filter(function(item) {
                return item.target_id !== targetId;
            });
            if(this.attendeeData.length < this.min_req_att) {
                this.dom.find(".search_target_button").show();
                super.cardFilledOutTriggers();
            }
        })
    }

    reloadMeetingAttendees(targetData) {
        this.attendeeData.push({target_id: targetData.target_id, 
            address_id: targetData.address_id,
            had_meal : targetData.had_meal,
            attFlags : targetData.attFlags
        })
        if(this.attendeeData.length >= this.min_req_att) {
            super.cardFilledOutTriggers();
        }
        this.datatable.row.add({
            firstname: targetData.firstname,
            lastname: targetData.lastname,
            degree: targetData.degree,
            address: targetData.address,
            city: targetData.city,
            state: targetData.state,
            target_id: targetData.target_id
        }).draw();
    }

    refreshAttendeeList(min_required_attendees) {
        this.dom.find("#min_req_att").text(min_required_attendees);
        this.datatable.clear().draw();  
        this.attendeeData = [];
        super.cardFilledOutTriggers();
    }

    canShowNextCard()
    {
        let can_show =
            (
                this.attendeeData.length >= this.min_req_att
            );

        return can_show;
    }
}
